// ============================================================
// types/curso.types.ts
// ============================================================

// ── Payload exacto → POST /cursos  y  PUT /cursos/{id} ───────
export interface CursoPayload {
  nombre:      string;
  descripcion: string;
  activo:      boolean;
}

// ── Estado interno del formulario ─────────────────────────────
export interface CursoFormState {
  nombre:      string;
  descripcion: string;
  activo:      boolean;
}

export const CURSO_FORM_INITIAL: CursoFormState = {
  nombre:      '',
  descripcion: '',
  activo:      true,
};
